import React, { useState, useEffect, useRef }  from 'react';
import { MaterialChooser, MaterialGroupChooser, PartMaterialsChooser, PrintingMethodChooser, DrawingOptions, RedrawButton, TagsAsOptions, SelectFlap, RedrawOnAllOptionChangesComplete, TechnicalPropertiesController, ComboButtonsSection } from 'components/show_drawing/redraw_form/index.js';
import { useForm  } from "react-hook-form";
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import Constants from 'components/show_drawing/Constants.jsx';
import MyEventListener from 'components/common/MyEventListener.jsx'

const RedrawForm = ( { id, userDowloadId, drawing, unit, setUnit, formRef, theme, setRedrawRequested, optionsUserChanged, addToOptionsUserChanged, removeFromOptionsUserChanged, redrawInProgress, setId, debug, GetRequestPath, currentDrawingOptions, currentUserDrawingOptions, addAddOnToDieline, removeAddOnFromDieline, addOnsAsQueryStr, advancedOptionsVisible, setAdvancedOptionsVisible, advancedOptionsHidden, resetEnabled, setResetEnabled, dimensionTextschecked, setDimensionTextschecked, initialOptions, technicalPropertiesEnabled, partMaterialsEnabled, comboEnabled, combos, activeCombosByGuestName, setActiveCombosByGuestName } ) => {
  const {register, handleSubmit, clearErrors, trigger, formState: { errors }} =  useForm();
  const [maxHeight, setMaxHeight] = useState(Constants.SVG_maxHeight);
  const [minHeight, setMinHeight] = useState(Constants.SVG_minHeight);
  const [redrawBtnClass, setRedrawBtnClass] = useState('');
  const [unitChangeDisabled, setUnitChangeDisabled] = useState(false);

  const myRef = useRef();
  const unitLabelRef = useRef();

  // True when any active combo guest has at least one advanced ask_option.
  // Used by DrawingOptions to decide whether to render the "Show advanced
  // options" toggle even when the host itself has no advanced options.
  const hasGuestAdvancedOptions = (combos || []).some((group) => {
    const activeId = activeCombosByGuestName[group.guest_name];
    if (!activeId) { return false; }
    const relation = group.relations.find((r) => r.id === activeId);
    return !!relation && (relation.ask_options || []).some((option) => option.advanced);
  });

  const emitUnitLabelWidth = () => {
    if (unitLabelRef.current) {
      emitEvent(Constants.drawing_input_label_width, { id: id, name: 'unit', width: $(unitLabelRef.current).width(), group: 'dropdowns' });
    }
  };

  const adjustUnitLabelWidthMsg = (e) => {
    if (e.detail.id == id && e.detail.name != 'unit' && e.detail.group == 'dropdowns' && unitLabelRef.current) {
      let myWidth = $(unitLabelRef.current).width();
      let othersWidth = e.detail.width;
      if (othersWidth > myWidth) {
        $(unitLabelRef.current).width(othersWidth);
      }
    }
  };

  const clearLocalStorage = () => {
    if( !isLocalStorageSupported() ) { return }
    if( drawing.main_id == undefined ) { return }
    let keyForLocalStorage = `fo_${drawing.main_id}_${unit}`;
    localStorage.removeItem(keyForLocalStorage);

    if(userDowloadId != undefined) {
      window.history.pushState( {} , drawing.page_title, drawing.path );
      location.reload();
    } else {
      emitEvent(Constants.drawing_reset_form, { id: id })
    }
  }

  const reset = (e) => {
    e.preventDefault();
    clearLocalStorage();
  }

  const onDownloadFinishedMsg = (msg) => {
    if(msg.detail.id == id) {
      clearLocalStorage()
    }
  }

  const resetLink = () => {
    const handleClick = (e) => {
      e.preventDefault();
      if (resetEnabled) {
        reset(e);
      }
    };

    return <div className={styles.reset_link}>
      <span className={styles.floatRight}>
        <small>
          <a
            href="#"
            onClick={handleClick}
            className={resetEnabled ? '' : styles.reset_link_disabled}
          >
            <i className="zmdi zmdi-undo"></i> { t('drawing.reset_form') }
          </a>
        </small>
      </span>
      <br />
      <br />
    </div>
  }

  const updateRedrawBtnClass = () => {
    setTimeout(updateRedrawBtnClass, 500);

    if ($(myRef.current).height() == undefined) { setRedrawBtnClass( () => ''); return; }
    var padding = 60;
    if (padding + $(myRef.current).height() +  $("#top-nav-header").height() < minHeight)  {
      setRedrawBtnClass( () =>  styles.bottom); return;
    }

    setRedrawBtnClass( () => '');
  }

  // useEffect
  useEffect(updateRedrawBtnClass, [resetEnabled, advancedOptionsVisible])

  useEffect(() => {
    return;
    setUnitChangeDisabled( () => true );
    setTimeout( () => {
      setUnitChangeDisabled( () => false );
    }, 1500 )
  }, [unit])

  useEffect(emitUnitLabelWidth, [unitLabelRef.current]);

  MyEventListener([
    {
      key: 'reset_requested',
      callback: clearLocalStorage
    },
    {
      key: Constants.drawing_input_label_width,
      callback: adjustUnitLabelWidthMsg
    }
  ])
  // useEffect end

  return (
    <div>
    <div className={styles.form_container} style={{ maxHeight: maxHeight, minHeight: minHeight }} >

      <div ref={myRef}>
        <RedrawOnAllOptionChangesComplete
          id={id}
          userDowloadId={userDowloadId}
          unit={unit}
          drawing={drawing}
          formRef={formRef}
          debug={debug}
          setResetEnabled={setResetEnabled}
          setRedrawRequested={setRedrawRequested}
          initialOptions={initialOptions}
        />

        <div className={styles.row}>
          <div className="input-group" style={{ width: '100%' }}>
            <span className={`d_input_add_on input-group-addon input-group-addon-${window.locale} ${styles.input_add_on}`} ref={unitLabelRef}>
              { t('my_drawings.options_unit_short') }
            </span>
            <select value={unit} onChange={(e) => setUnit(e.target.value)} className="form-control" disabled={unitChangeDisabled}>
              <option value="mm"> { t('drawing.unit_mm') } </option>
              <option value="infr"> { t('drawing.unit_infr') } </option>
              <option value="in"> { t('drawing.unit_in') } </option>
            </select>
          </div>
        </div>

        <input type="hidden" name="unit" value={unit} />
        <input type="hidden" name="user_unit" value={unit} />
        <input type="hidden" name="id" value={id} />
        {comboEnabled && <input type="hidden" name="combo_ids" value={Object.values(activeCombosByGuestName).join(',')} />}

        <MaterialGroupChooser id={id} setId={setId} unit={unit} drawing={drawing}/>

        <MaterialChooser id={id} unit={unit} drawing={drawing} register={register} errors={errors}/>

        {partMaterialsEnabled && <PartMaterialsChooser id={id} unit={unit} register={register} errors={errors} />}

        {technicalPropertiesEnabled && <TechnicalPropertiesController
          id={id}
          unit={unit}
          setId={setId}
          unit={unit}
          drawing={drawing}
          theme={theme}
          debug={debug}
          optionsUserChanged={optionsUserChanged}
          formRef={formRef}
        />}

        {drawing.ask_offset && <PrintingMethodChooser id={id} unit={unit} drawing={drawing} /> }

        {!technicalPropertiesEnabled && <TagsAsOptions id={id} setId={setId} drawing={drawing} theme={theme} debug={debug} /> }

        <DrawingOptions
          id={id}
          unit={unit}
          drawing={drawing}
          register={register}
          errors={errors}
          optionsUserChanged={optionsUserChanged}
          addToOptionsUserChanged={addToOptionsUserChanged}
          removeFromOptionsUserChanged={removeFromOptionsUserChanged}
          debug={debug}
          setMaxHeight={setMaxHeight}
          setRedrawRequested={setRedrawRequested}
          customerAddOnsEnabled={drawing.customer_add_ons_enabled}
          GetRequestPath={GetRequestPath}
          currentDrawingOptions={currentDrawingOptions}
          addAddOnToDieline={addAddOnToDieline}
          removeAddOnFromDieline={removeAddOnFromDieline}
          addOnsAsQueryStr={addOnsAsQueryStr}
          advancedOptionsVisible={advancedOptionsVisible}
          setAdvancedOptionsVisible={setAdvancedOptionsVisible}
          advancedOptionsHidden={advancedOptionsHidden}
          hasGuestAdvancedOptions={hasGuestAdvancedOptions}
          dimensionTextschecked={dimensionTextschecked}
          setDimensionTextschecked={setDimensionTextschecked}
        />

        {comboEnabled && (
          <ComboButtonsSection
            combos={combos}
            activeCombosByGuestName={activeCombosByGuestName}
            setActiveCombosByGuestName={setActiveCombosByGuestName}
            setRedrawRequested={setRedrawRequested}
            unit={unit}
            register={register}
            errors={errors}
            drawingMainId={drawing.main_id}
            advancedOptionsVisible={advancedOptionsVisible}
          />
        )}

        <div className={redrawBtnClass}>
          <RedrawButton id={id} unit={unit} setRedrawRequested={setRedrawRequested} redrawInProgress={redrawInProgress} />
          { resetLink() }
        </div>
      </div>

    </div>

    </div>
  )
}

export default RedrawForm;
